<template>
  <div>
    <div class="col s12 panel boxed padded60 dataGroup tab-content" :class="{[sensor.id]: true}">
      <div class="button-section-wrapper">
        <span id="people" vcloak v-if="canCreateProject">
          <button class="btn btn-success  projectAdd" @click="createProject"> <span style="font-size: 20px;" :class="{'ion-ios-mic': sensor.id =='ARU',
              'ion-ios-camera': sensor.id == 'CAM'}"></span> Add {{sensor.label}} Project</button>
        </span>
        <span v-if="toggleInitSetting !== null" class="project-toggle"> View only my projects <ToggleButton :value="toggleInitSetting" :sync="true" color="#C94412" @change="switchProjectView"></ToggleButton></span>
      </div>

      <v-server-table ref="table" v-if="optionLoaded" :url="url" :columns="columns" :options="tableOptions" class="table vue-bordered"
        @row-click="onRowClick" @loaded="tableLoaded()">
        <!-- a slot="edit" slot-scope="props" class="fa fa-edit" :href="edit(props.row.common_name)"></a -->
        <template slot="shortNm" slot-scope="props">
          <a v-if="isSensorAdmin || props.row.requestingUserAdmin" class="editProject modal-trigger projectAdd" @click="updateProject(props.row)"><span class="ion-edit"></span></a>
        </template>
        <template slot="fullNm" slot-scope="props">
          <a :href="taskRowUrl(props.row.id)" v-if="props.row.hasProjectAccess && !props.row.status.includes('Pending')">{{props.row.fullNm}}</a>
          <span v-if="props.row.status.includes('Pending') || !props.row.hasProjectAccess">{{props.row.fullNm}}</span>
        </template>
        <div class="row" slot="child_row" slot-scope="props">
          <div class="col s12 m12 l12">
            <p class="left-align">{{props.row.description}}</p>
            <button v-if="props.row.canRequestAccess" class="float-right btn btn-border" @click="requestAccess(props.row)">Request Access</button>
            <div v-if="props.row.requestingUserAdmin" class="right">
              <div class="merge-wrapper" v-tooltip="{content: !(props.row.requestingUserAdmin && props.row.status === 'Active') ? 'You must be an admin and the project status must be Active to merge a project': null}">
                <button :disabled="!(props.row.requestingUserAdmin && props.row.status === 'Active')" class="btn btn-success" @click="openMergeModal(props.row)">Merge Project</button>
              </div>
              <div class="single-btn-wrapper" v-tooltip="{content: props.row.tasksCount > 0 ? 'Project cannot be deleted if there are existing tasks': null}">
                <button class="btn" @click="deleteProject(props.row)" :disabled="props.row.tasksCount > 0"> <span style="font-size: 20px;"></span>Delete Project</button>
              </div>
            </div>
          </div>
          <!--div class="col s12 m6 l3 subrow-info stats">
            <p><label>Due Date:</label> {{props.row.dueDate}}</p>
            <p><label>Species Identified:</label> {{props.row.speciesCount}}</p>
          </div>
          <div class="col s12 m6 l3 subrow-info stats">
            <p><label>Total Tasks:</label> {{props.row.tasksCount}}</p>
            <p><label>Completed Tasks:</label> {{props.row.tasksCompletedCount}}</p>
          </div-->
        </div>
      </v-server-table>
    </div>
    <modal name="project"
      :scrollable="true" :adaptive="true"
      transition="nice-modal-fade"
      classes="modal-form scroll"
      draggable=".drag-handle"
      :delay="100"
      width = "55%"
      height = "620"
      :minWidth="400"
      :minHeight="540"
      :clickToClose = "false"
    >
      <project-form ref="projectForm" v-if="projectId != -1" v-bind:project-id="projectId" v-bind:active-sensor="sensor.id" v-bind:options="options"
      />
    </modal>

      <modal name="requestAccess"
      :scrollable="true" :adaptive="true"
      transition="nice-modal-fade"
      classes="modal-form scroll"
      draggable=".drag-handle"
      :delay="100"
      width = "75%"
      height = "620"
      :minWidth="400"
      :minHeight="540"
      :clickToClose = "false"
    >
      <project-access-request-form ref="projectAccessRequestForm" v-if="projectId != -1"
      v-bind:project-id="projectId" v-bind:projectName="projectName" v-bind:organizationId="organizationId" v-bind:organizationName="organizationName"
      />
    </modal>
    <modal name="merge-form"
      :scrollable="true" :adaptive="true"
      transition="nice-modal-fade"
      classes="modal-form scroll"
      draggable=".drag-handle"
      :delay="100"
      width="55%"
      height="auto"
      :minWidth="400"
      :minHeight="500"
      :clickToClose="false"
    >
      <merge-locations-form ref="mergeLocationForm" v-if="mergeSourceInfo" v-bind:mergeSourceInfo="mergeSourceInfo" v-bind:merge-type="'project'"
      />
      </modal>
  </div>
</template>

<script>
/* this component show two tabs + stats + notification for all projects
under each project tab, show a table listing all projects. users can also update project properties + users
or remove projects if they have no associated data.
*/
import Vue from 'vue';
import VueTables from 'vue-tables-2';
import VueResource from 'vue-resource';
import ProjectForm from './ProjectForm';
import ProjectAccessRequestForm from './ProjectAccessRequestForm';
import {eventBus} from '@/lib/eventbus';
import {API_URL} from '@/lib/common';
import FormMixin from '@/components/common/FormMixin.js';
import { ToggleButton } from 'vue-js-toggle-button';
import MergeFormVue from '../organization/MergeForm.vue';

Vue.use(VueResource);
Vue.use(VueTables.ServerTable);
Vue.component('ToggleButton', ToggleButton);

export default {
  name: 'ProjectTable',
  props: ['sensor', 'showAdminOnlyProjects'],
  components: {
    'project-form': ProjectForm,
    'project-access-request-form': ProjectAccessRequestForm,
    'ToggleButton': ToggleButton,
    'merge-locations-form': MergeFormVue
  },
  mixins: [FormMixin],
  async created () {
    const self = this;
    this.getPermissions();
    await this.$http.get(API_URL + 'project-options').then(
      function (response) {
        this.options = response.data;
        let status = [];
        this.options.status.forEach(function (e) {
          status.push({id: e.type, text: e.type});
        })
        this.$set(this.tableOptions.listColumns, 'status', status);
      });

    await this.getOrgs();
    this.setupTableHeadings(this.sensor.id);
    this.optionLoaded = true;

    eventBus.$on('reload-table', function () {
      self.$refs.table.refresh();
    });
    eventBus.$on('reload-project-form', function (projectId) {
      self.projectId = projectId;
    });
    eventBus.$on('close-project-form', function (projectId) {
      self.projectId = -1;
    });
    eventBus.$on('close-merge-form', function () {
      self.mergeSourceInfo = null;
    });
  },
  methods: {
    getPermissions () {
      this.isProjectAdmin = this.sensor.isManagerOfAnyProject;
      this.isSensorAdmin = this.sensor.isSensorAdmin;
      this.canCreateProject = this.sensor.isSensorAdmin || this.sensor.canUserCreateProjects;
    },
    showHideStatusColumn (isProjectAdmin) {
      // if (isAdmin) {
      //   if (!this.columns.includes('status')) {
      //     this.columns.splice(this.columns.indexOf('tasksCount'), 0, 'status');
      //   }
      // }
      // else {
      //    if (this.columns.includes('status')) {
      //     this.columns.splice(this.columns.indexOf('status'), 1);
      //   }
      // }
    },
    updateProject (row) {
      if (row.requestingUserAdmin) {
        this.projectId = row.id;
        this.showProjectForm();
      }
    },
    createProject () {
      this.projectId = null;
      this.showProjectForm();
    },
    deleteProject (row) {
      this.commonDelete(this.projectRemoveUrl, {projectIds: [row.id]}, () => {
        this.$refs.table.refresh();
      });
    },
    showProjectForm () {
      //  console.log('projectId =', this.projectId)
      // this.$refs.projectForm.switchProject();
      this.$modal.show('project');
    },
    initTable () {
      this.tableData = [];
      // console.log(this === this.$refs['table']);
      // this.$refs['table'].refresh();
    },
    taskRowUrl: function (id) {
      return this.sensor.url + '.html?projectId=' + id + '&sensorId=' + this.sensor.id;
    },
    onRowClick (event) {
      this.tableOptions.activeRowId = event.row.id;
    },
    tableLoaded () {
      /*
      Only do this the first time table is loaded
      if user has at least 1 project, can set toggle to view only theirs
      If not, see all projects
          */
      if (!this.tableLoadedOnce) {
        this.tableLoadedOnce = true;
        if (this.$refs.table.data.length > 0) {
          // user has at least one project
          this.tableOptions.isProjectMember = true;
          this.toggleInitSetting = true;
        } else {
          this.toggleInitSetting = false;
          this.tableOptions.isProjectMember = false;
        }
        this.$refs.table.refresh();
      }
    },
    async getOrgs () {
      await this.commonGet(API_URL + 'get-project-summary-organizations', { params: { sensorId: this.sensor.id } }, false, (response) => {
        this.$set(this.tableOptions.listColumns, 'organizationId', response.data.map(x => { return {id: x.id, text: x.name}; }));
      });
    },
    requestAccess (row) {
      this.organizationName = row.organizationId;
      this.organizationId = this.getOrganizationIdNumber(row.organizationId);
      this.projectName = row.fullNm;
      this.projectId = row.id;
      this.$modal.show('requestAccess');
    },
    getOrganizationIdNumber (organizationText) {
      var tmp = this.tableOptions.listColumns['organizationId'].filter(org => {
        if (org.text === organizationText) {
          return org;
        }
      });
      return tmp[0].id;
    },
    switchProjectView () {
      // switch between showing all projects and only the projects where the user is a member
      this.toggleInitSetting = !this.toggleInitSetting;
      this.tableOptions.isProjectMember = !this.tableOptions.isProjectMember;
      this.$refs.table.refresh();
    },
    setupTableHeadings (sensorId) {
      if (sensorId === 'PC') {
        this.columns = [ 'year', 'fullNm', 'organizationId', 'status', 'tasksCompletedCount', 'shortNm' ];
        this.tableOptions.filterable = ['year', 'fullNm', 'status', 'organizationId'];
        this.tableOptions.headings.tasksCompletedCount = 'Total Surveys';
      } else {
        this.columns = [ 'year', 'fullNm', 'organizationId', 'status', 'dueDate', 'tasksCount', 'tasksCompletedCount', 'shortNm' ];
        this.tableOptions.filterable = ['year', 'fullNm', 'status', 'dueDate', 'organizationId'];
        this.tableOptions.headings.tasksCompletedCount = 'Completed Tasks';
      }
    },
    openMergeModal (row) {
      this.mergeSourceInfo = row;
      this.$modal.show('merge-form');
    }
  },
  watch: {
    sensor: async function (newVal, oldVal) {
      this.url = API_URL + 'get-project-summary?sensorId=' + newVal.id;
      this.getPermissions();
      for (var key in this.$refs['table'].query) {
        this.$refs['table'].query[key] = '';
      }
      await this.getOrgs();
      this.setupTableHeadings(newVal.id);
      this.tableOptions.headings.fullNm = this.sensor.label + ' Project Name';

      this.$refs['table'].refresh();
    }
  },
  data () {
    const pageSize = 100;
    return {
      url: API_URL + 'get-project-summary?sensorId=' + this.sensor.id + '&adminOnlyProjects=' + this.showAdminOnlyProjects,
      projectUpdateUrl: API_URL + 'insert-update-project',
      projectRemoveUrl: API_URL + 'delete-project',
      recordName: 'project',
      toggleInitSetting: null,
      tableLoadedOnce: false,
      projectId: null,
      projectName: null,
      organizationId: null,
      organizationName: null,
      mergeSourceInfo: null,
      columns: [ 'year', 'fullNm', 'organizationId', 'status', 'dueDate', 'tasksCount', 'tasksCompletedCount', 'shortNm' ],
      customFilters: ['projectType'],
      isProjectAdmin: null,
      isSensorAdmin: null,
      canCreateProject: false,
      options: {},
      optionLoaded: false,
      tableOptions: {
        isProjectMember: true, // show if the user is a project member or not
        activeRowId: null,
        highlightMatches: true,
        childRowTogglerFirst: false,
        filterByColumn: true,
        filterable: ['year', 'fullNm', 'status', 'dueDate', 'organizationId'], // 'dueDate' can't sort or filter dueDate as
        sortable: ['year', 'fullNm', 'status', 'tasksCount', 'tasksCompletedCount', 'dueDate', 'organizationId'],
        listColumns: {},
        headings: {
          year: 'Year',
          fullNm: ' Project Name',
          organizationId: 'Organization',
          dueDate: 'Due Date',
          tasksCount: 'Total Tasks',
          tasksCompletedCount: 'Completed Tasks',
          shortNm: 'Details'
        },
        columnsClasses: {
          year: 'year',
          dueDate: 'dueDate',
          status: 'status',
          fullNm: 'name',
          tasksCount: 'tasks',
          tasksCompletedCount: 'completed',
          shortNm: 'details'
        },
        debounce: 1000, // one second debounce
        perPage: 100,
        perPageValues: [25, 50, 75, 100],
        pagination: {
          nav: 'fixed',
          edge: true},
        texts: {
          count: 'Showing {from} to {to} of {count} records|{count} records|One record',
          first: 'First',
          last: 'Last',
          // filter: 'Filter:',
          // filterPlaceholder: 'Search query',
          limit: 'Records Per Page:',
          page: 'Page:',
          noResults: 'No matching records',
          filterBy: 'Filter by {column}',
          loading: 'Loading...',
          defaultOption: 'Select {column}',
          columns: 'Columns'
        },
        // initFilters: {status: 'Active'},
        orderBy: {column: 'year', ascending: false},
        rowClassCallback (row) {
          return (row.id === this.activeRowId ? 'activeTableRow' : '');
        },
        requestAdapter (data) {
          let filter = [];
          const query = data.query;
          if (query) {
            Object.keys(query).forEach(function (key) {
              filter.push({column: key, value: query[key]});
            });
          }
          if (this.isProjectMember) {
            filter.push({column: 'isProjectMember', value: this.isProjectMember}); // set if it  member or not
          }
          return {
            sort: data.orderBy ? data.orderBy : this.orderBy.column,
            order: data.ascending ? 'asc' : 'desc',
            limit: data.limit ? data.limit : pageSize,
            page: data.page ? data.page : 1,
            filters: filter
          }
        },
        responseAdapter (data) {
          if (data && data.total_row_count > 0) {
            return {
              data: data.results,
              count: data.total_row_count
            };
          } else {
            return { data: [], count: 0 };
          }
        }
      }
    }
  }
}
</script>
<style>
.subrow-info p {
  color: #C94412;
}
th.name {
  width: 30%;
}
th.details {
  width: 3%;
}
th.year, th.tasks {
  width: 10%;
}
th.completed {
  width: 12%;
}
th.dueDate {
  width: 10%
}
th.status  {
  width: 15%;
}
.VueTables__table td,
.VueTables__table th {
  text-align: center;
}
.VueTables__table td.name,
.VueTables__table th.name {
  text-align: left;
}

.VueTables__child-row-toggler {
  cursor: pointer;
}

.float-right{
  float: right;
}

.vue-js-switch{
  padding-left: 5px;
}

.button-section-wrapper{
  display:flex;
  flex-direction: row;
  align-items: center;

}

.project-toggle{
  margin-bottom: 10px; /* To match the margin on the 2 buttons */
  margin-left: auto;
  font-weight: 600;
  /*border-radius: 2px;
  border: solid #d6a491 1px;*/
}

.single-btn-wrapper{
  /* this element and css needed in order to show tooltip on disabled btn */
  display: inline-block;
}

.merge-wrapper{
  display: inline;
}
</style>
